export class FilesAction {

    public static getFullFile: string = '[Accounts] get_full_file';
    public static getFullFileError: string = '[Accounts] get_full_file_error';
    public static getFullFileSuccess: string = '[Accounts] get_full_file_success';

    public static getBlobFile: string = '[Accounts] get_blob_file';
    public static getBlobFileError: string = '[Accounts] get_blob_file_error';
    public static getBlobFileSuccess: string = '[Accounts] get_blob_file_success';

    public static getLogoFile: string = '[Accounts] get_logo_file';
    public static getLogoFileError: string = '[Accounts] get_logo_file_error';
    public static getLogoFileSuccess: string = '[Accounts] get_logo_file_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
